import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  message?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

const DEFAULT_ICON = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <circle cx="16" cy="16" r="13" stroke="currentColor" strokeWidth="1.5" />
    <path d="M11 16h10M16 11v10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

/**
 * Replaces the prior flat single-line empty-state text with an icon,
 * explanatory title, optional longer message, and optional action —
 * per the audit finding that bare "No X yet." text gives the user no
 * sense of why it's empty or what happens next.
 */
export function EmptyState({ title, message, icon = DEFAULT_ICON, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <span className="empty-state-icon">{icon}</span>
      <p className="empty-state-title">{title}</p>
      {message ? <p className="empty-state-message">{message}</p> : null}
      {action ?? null}
    </div>
  );
}
